
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("j4h3r", function(module, exports) {
$parcel$export(module.exports, "default", () => $659ec04a45a98ca8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $4eo0T = parcelRequire("4eo0T");

var $47PJr = parcelRequire("47PJr");

var $bYAVs = parcelRequire("bYAVs");

var $grxpp = parcelRequire("grxpp");

var $8I00b = parcelRequire("8I00b");

var $aConP = parcelRequire("aConP");

const $659ec04a45a98ca8$var$LazyAkCodeBlock = /*#__PURE__*/ (0, $eJOHy.lazy)(// Ignored via go/ees005
// eslint-disable-next-line require-await
async ()=>(parcelRequire("5rPMS")));
const $659ec04a45a98ca8$var$joinWithSpaces = (...strs)=>strs.join(' ');
const $659ec04a45a98ca8$var$MemoizedLightWeightCodeBlock = /*#__PURE__*/ (0, $eJOHy.memo)((0, $8I00b.default));
const $659ec04a45a98ca8$var$WindowedCodeBlock = ({ text: text, language: language, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, className: rootClassName })=>{
    const { warningLabel: warningLabel } = (0, $grxpp.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const { isInViewport: isInViewport, trackingRef: trackingRef } = (0, $bYAVs.useInViewport)();
    const className = $659ec04a45a98ca8$var$joinWithSpaces((0, $4eo0T.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, rootClassName);
    const memoizedLightWeightCodeBlock = /*#__PURE__*/ (0, $1NIU8.jsx)($659ec04a45a98ca8$var$MemoizedLightWeightCodeBlock, {
        ref: trackingRef,
        text: text,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: rootClassName
    });
    const [wrapLongLines, setWrapLongLines] = (0, $eJOHy.useState)(false);
    return isInViewport ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Suspense), {
        fallback: memoizedLightWeightCodeBlock
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aConP.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($659ec04a45a98ca8$var$LazyAkCodeBlock, {
        language: language,
        text: text,
        codeBidiWarningLabel: warningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines,
        hasBidiWarnings: (0, $47PJr.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true) ? false : undefined
    })))) : memoizedLightWeightCodeBlock;
};
var $659ec04a45a98ca8$export$2e2bcd8739ae039 = $659ec04a45a98ca8$var$WindowedCodeBlock;

});
parcelRegister("bYAVs", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $0e5994c609ac731d$export$6215040b989f9b0f);

var $eJOHy = parcelRequire("eJOHy");
const $0e5994c609ac731d$export$6215040b989f9b0f = ()=>{
    const trackingRef = (0, $eJOHy.useRef)(null);
    const [isInViewport, setIsInViewport] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!trackingRef || !trackingRef?.current) return;
        const target = trackingRef.current;
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries)if (entry.isIntersecting) setIsInViewport(true);
        });
        observer.observe(target);
        return ()=>observer.disconnect();
    }, [
        trackingRef
    ]);
    return {
        isInViewport: isInViewport,
        trackingRef: trackingRef
    };
};

});

parcelRegister("aConP", function(module, exports) {
$parcel$export(module.exports, "default", () => $54dd201e64bd5a96$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $4eo0T = parcelRequire("4eo0T");

var $91hOG = parcelRequire("91hOG");

var $47PJr = parcelRequire("47PJr");

var $1fVOO = parcelRequire("1fVOO");
const $54dd201e64bd5a96$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $1NIU8.css)({
    tabSize: 4,
    backgroundColor: `var(--ds-surface-raised, ${(0, $5d8ec86348a5c657$export$9fdfb749e33cdf97)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $4eo0T.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $54dd201e64bd5a96$var$denseModeOverrides = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $4eo0T.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5em'
    }
});
const $54dd201e64bd5a96$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, localId: localId, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-local-id": localId,
        css: [
            $54dd201e64bd5a96$var$codeBlockStyleOverrides,
            (0, $47PJr.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $91hOG.fg)('platform_editor_content_mode_button_mvp') && $54dd201e64bd5a96$var$denseModeOverrides
        ]
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1fVOO.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $54dd201e64bd5a96$export$2e2bcd8739ae039 = $54dd201e64bd5a96$var$CodeBlockContainer;

});
var $5d8ec86348a5c657$exports = {};
$parcel$export($5d8ec86348a5c657$exports, "R50", () => $5d8ec86348a5c657$export$4b84fd0e2c617bd);
$parcel$export($5d8ec86348a5c657$exports, "R75", () => $5d8ec86348a5c657$export$b34b069eff244586);
$parcel$export($5d8ec86348a5c657$exports, "R100", () => $5d8ec86348a5c657$export$be802dd0d8b57f35);
$parcel$export($5d8ec86348a5c657$exports, "R200", () => $5d8ec86348a5c657$export$60847d42f9da92a6);
$parcel$export($5d8ec86348a5c657$exports, "R300", () => $5d8ec86348a5c657$export$4a7404f376229999);
$parcel$export($5d8ec86348a5c657$exports, "R400", () => $5d8ec86348a5c657$export$2010d0fb4295b346);
$parcel$export($5d8ec86348a5c657$exports, "R500", () => $5d8ec86348a5c657$export$2837b5a1a71d5c02);
$parcel$export($5d8ec86348a5c657$exports, "Y50", () => $5d8ec86348a5c657$export$8d9596b529bbb9cf);
$parcel$export($5d8ec86348a5c657$exports, "Y75", () => $5d8ec86348a5c657$export$41060a744ab0b7ae);
$parcel$export($5d8ec86348a5c657$exports, "Y100", () => $5d8ec86348a5c657$export$1cc05bbbf340e559);
$parcel$export($5d8ec86348a5c657$exports, "Y200", () => $5d8ec86348a5c657$export$5aae31392d72caaa);
$parcel$export($5d8ec86348a5c657$exports, "Y300", () => $5d8ec86348a5c657$export$c6930421db9fa514);
$parcel$export($5d8ec86348a5c657$exports, "Y400", () => $5d8ec86348a5c657$export$59619663aa6500fb);
$parcel$export($5d8ec86348a5c657$exports, "Y500", () => $5d8ec86348a5c657$export$874739ea9e379ab6);
$parcel$export($5d8ec86348a5c657$exports, "G50", () => $5d8ec86348a5c657$export$8a6341c32b6a3ee6);
$parcel$export($5d8ec86348a5c657$exports, "G75", () => $5d8ec86348a5c657$export$69a3bf21b9686c2b);
$parcel$export($5d8ec86348a5c657$exports, "G100", () => $5d8ec86348a5c657$export$afbce1382ec95f73);
$parcel$export($5d8ec86348a5c657$exports, "G200", () => $5d8ec86348a5c657$export$747d86715d4175de);
$parcel$export($5d8ec86348a5c657$exports, "G300", () => $5d8ec86348a5c657$export$940e1f69e873f202);
$parcel$export($5d8ec86348a5c657$exports, "G400", () => $5d8ec86348a5c657$export$a49394138f7b8e85);
$parcel$export($5d8ec86348a5c657$exports, "G500", () => $5d8ec86348a5c657$export$6fa04827ac68a4fb);
$parcel$export($5d8ec86348a5c657$exports, "B50", () => $5d8ec86348a5c657$export$226de0355ed012f8);
$parcel$export($5d8ec86348a5c657$exports, "B75", () => $5d8ec86348a5c657$export$8c13c2ee36917869);
$parcel$export($5d8ec86348a5c657$exports, "B100", () => $5d8ec86348a5c657$export$ecfc1dff386a3e7a);
$parcel$export($5d8ec86348a5c657$exports, "B200", () => $5d8ec86348a5c657$export$215b7063051591f1);
$parcel$export($5d8ec86348a5c657$exports, "B300", () => $5d8ec86348a5c657$export$e62e8919cca44969);
$parcel$export($5d8ec86348a5c657$exports, "B400", () => $5d8ec86348a5c657$export$b3de0ae08da2ce64);
$parcel$export($5d8ec86348a5c657$exports, "B500", () => $5d8ec86348a5c657$export$a6ee3d71bc067634);
$parcel$export($5d8ec86348a5c657$exports, "B600", () => $5d8ec86348a5c657$export$67f15409e87642a1);
$parcel$export($5d8ec86348a5c657$exports, "B700", () => $5d8ec86348a5c657$export$f0539dbc42dbb067);
$parcel$export($5d8ec86348a5c657$exports, "P50", () => $5d8ec86348a5c657$export$363e4475840015bb);
$parcel$export($5d8ec86348a5c657$exports, "P75", () => $5d8ec86348a5c657$export$4b0a4417ed59760f);
$parcel$export($5d8ec86348a5c657$exports, "P100", () => $5d8ec86348a5c657$export$6011520a64d9a187);
$parcel$export($5d8ec86348a5c657$exports, "P200", () => $5d8ec86348a5c657$export$a7175d4e9206bc80);
$parcel$export($5d8ec86348a5c657$exports, "P300", () => $5d8ec86348a5c657$export$b48405b95304b5a1);
$parcel$export($5d8ec86348a5c657$exports, "P400", () => $5d8ec86348a5c657$export$c71e4279dd54a18d);
$parcel$export($5d8ec86348a5c657$exports, "P500", () => $5d8ec86348a5c657$export$147899de772240ec);
$parcel$export($5d8ec86348a5c657$exports, "T50", () => $5d8ec86348a5c657$export$2cf711fe14c66f06);
$parcel$export($5d8ec86348a5c657$exports, "T75", () => $5d8ec86348a5c657$export$7a8f4d33f6f9772c);
$parcel$export($5d8ec86348a5c657$exports, "T100", () => $5d8ec86348a5c657$export$776c9c497ef08533);
$parcel$export($5d8ec86348a5c657$exports, "T200", () => $5d8ec86348a5c657$export$69cb3ca10c1e330e);
$parcel$export($5d8ec86348a5c657$exports, "T300", () => $5d8ec86348a5c657$export$9dc1ef0f3f48059b);
$parcel$export($5d8ec86348a5c657$exports, "T400", () => $5d8ec86348a5c657$export$7c835c78b6fcdef8);
$parcel$export($5d8ec86348a5c657$exports, "T500", () => $5d8ec86348a5c657$export$6036577f95c3877e);
$parcel$export($5d8ec86348a5c657$exports, "N0", () => $5d8ec86348a5c657$export$29a4f05edc054374);
$parcel$export($5d8ec86348a5c657$exports, "N10", () => $5d8ec86348a5c657$export$e655ef011c4aa1a2);
$parcel$export($5d8ec86348a5c657$exports, "N20", () => $5d8ec86348a5c657$export$9fdfb749e33cdf97);
$parcel$export($5d8ec86348a5c657$exports, "N30", () => $5d8ec86348a5c657$export$3e51e8f1440314ba);
$parcel$export($5d8ec86348a5c657$exports, "N40", () => $5d8ec86348a5c657$export$1ce2d1575d444ceb);
$parcel$export($5d8ec86348a5c657$exports, "N50", () => $5d8ec86348a5c657$export$8754fc7e6d8b3000);
$parcel$export($5d8ec86348a5c657$exports, "N60", () => $5d8ec86348a5c657$export$c2e91cbeada39b8b);
$parcel$export($5d8ec86348a5c657$exports, "N70", () => $5d8ec86348a5c657$export$5f71e19f3a7ad9de);
$parcel$export($5d8ec86348a5c657$exports, "N80", () => $5d8ec86348a5c657$export$eaa8c8a70ac22806);
$parcel$export($5d8ec86348a5c657$exports, "N90", () => $5d8ec86348a5c657$export$7c87d337fb91a97d);
$parcel$export($5d8ec86348a5c657$exports, "N100", () => $5d8ec86348a5c657$export$d6447c357493214f);
$parcel$export($5d8ec86348a5c657$exports, "N200", () => $5d8ec86348a5c657$export$f563ee71e9ee74cd);
$parcel$export($5d8ec86348a5c657$exports, "N300", () => $5d8ec86348a5c657$export$e2ef2124cf4024b1);
$parcel$export($5d8ec86348a5c657$exports, "N400", () => $5d8ec86348a5c657$export$eece5f492e429f08);
$parcel$export($5d8ec86348a5c657$exports, "N500", () => $5d8ec86348a5c657$export$c39c0fe0f26207ae);
$parcel$export($5d8ec86348a5c657$exports, "N600", () => $5d8ec86348a5c657$export$7090862dc3038a9f);
$parcel$export($5d8ec86348a5c657$exports, "N700", () => $5d8ec86348a5c657$export$ad0bacf983b7ddaa);
$parcel$export($5d8ec86348a5c657$exports, "N800", () => $5d8ec86348a5c657$export$7d61b15e0da132af);
$parcel$export($5d8ec86348a5c657$exports, "N900", () => $5d8ec86348a5c657$export$fbda843f0a27fe96);
$parcel$export($5d8ec86348a5c657$exports, "N10A", () => $5d8ec86348a5c657$export$791e57b27ca738ef);
$parcel$export($5d8ec86348a5c657$exports, "N20A", () => $5d8ec86348a5c657$export$8d43898f60b96a82);
$parcel$export($5d8ec86348a5c657$exports, "N30A", () => $5d8ec86348a5c657$export$920c0d5c49070351);
$parcel$export($5d8ec86348a5c657$exports, "N40A", () => $5d8ec86348a5c657$export$46987b49aab6d1a8);
$parcel$export($5d8ec86348a5c657$exports, "N50A", () => $5d8ec86348a5c657$export$7d3359664e8bb0e5);
$parcel$export($5d8ec86348a5c657$exports, "N60A", () => $5d8ec86348a5c657$export$d2d3bedfb276cac0);
$parcel$export($5d8ec86348a5c657$exports, "N70A", () => $5d8ec86348a5c657$export$6e5e7499ff054f6d);
$parcel$export($5d8ec86348a5c657$exports, "N80A", () => $5d8ec86348a5c657$export$59264b346c877fa7);
$parcel$export($5d8ec86348a5c657$exports, "N90A", () => $5d8ec86348a5c657$export$d092757d7c64925c);
$parcel$export($5d8ec86348a5c657$exports, "N100A", () => $5d8ec86348a5c657$export$486ab785e4bac3c6);
$parcel$export($5d8ec86348a5c657$exports, "N200A", () => $5d8ec86348a5c657$export$fba592bbc6419fea);
$parcel$export($5d8ec86348a5c657$exports, "N300A", () => $5d8ec86348a5c657$export$13609db0e6812ab8);
$parcel$export($5d8ec86348a5c657$exports, "N400A", () => $5d8ec86348a5c657$export$fbae4efaa892d883);
$parcel$export($5d8ec86348a5c657$exports, "N500A", () => $5d8ec86348a5c657$export$f13946d26f440ce6);
$parcel$export($5d8ec86348a5c657$exports, "N600A", () => $5d8ec86348a5c657$export$19f58225ac52a306);
$parcel$export($5d8ec86348a5c657$exports, "N700A", () => $5d8ec86348a5c657$export$6384f09da70e7b62);
$parcel$export($5d8ec86348a5c657$exports, "N800A", () => $5d8ec86348a5c657$export$d0dccc730683edc2);
$parcel$export($5d8ec86348a5c657$exports, "DN900", () => $5d8ec86348a5c657$export$2f6319cf7d736c2a);
$parcel$export($5d8ec86348a5c657$exports, "DN800", () => $5d8ec86348a5c657$export$95126bc8884d6634);
$parcel$export($5d8ec86348a5c657$exports, "DN700", () => $5d8ec86348a5c657$export$8338d8c35d44ff1);
$parcel$export($5d8ec86348a5c657$exports, "DN600", () => $5d8ec86348a5c657$export$5368d76ae4fbbda7);
$parcel$export($5d8ec86348a5c657$exports, "DN500", () => $5d8ec86348a5c657$export$9f0a771d16ec8d36);
$parcel$export($5d8ec86348a5c657$exports, "DN400", () => $5d8ec86348a5c657$export$abcf8c38338b4aa5);
$parcel$export($5d8ec86348a5c657$exports, "DN300", () => $5d8ec86348a5c657$export$97e81faa16a182c7);
$parcel$export($5d8ec86348a5c657$exports, "DN200", () => $5d8ec86348a5c657$export$bfe21c59123ecf33);
$parcel$export($5d8ec86348a5c657$exports, "DN100", () => $5d8ec86348a5c657$export$ee82aa2ea6a1558);
$parcel$export($5d8ec86348a5c657$exports, "DN90", () => $5d8ec86348a5c657$export$682927c6ed76be02);
$parcel$export($5d8ec86348a5c657$exports, "DN80", () => $5d8ec86348a5c657$export$91fd9994c5be9757);
$parcel$export($5d8ec86348a5c657$exports, "DN70", () => $5d8ec86348a5c657$export$d281fbfe3cff2df6);
$parcel$export($5d8ec86348a5c657$exports, "DN60", () => $5d8ec86348a5c657$export$3902c91d8b98a753);
$parcel$export($5d8ec86348a5c657$exports, "DN50", () => $5d8ec86348a5c657$export$8e8133c1ba5845b5);
$parcel$export($5d8ec86348a5c657$exports, "DN40", () => $5d8ec86348a5c657$export$33ff357f6620b39);
$parcel$export($5d8ec86348a5c657$exports, "DN30", () => $5d8ec86348a5c657$export$633847cf062b69e0);
$parcel$export($5d8ec86348a5c657$exports, "DN20", () => $5d8ec86348a5c657$export$9776a6e503bdbf76);
$parcel$export($5d8ec86348a5c657$exports, "DN10", () => $5d8ec86348a5c657$export$6c813d5160dff5db);
$parcel$export($5d8ec86348a5c657$exports, "DN0", () => $5d8ec86348a5c657$export$3d4f271a500072a);
$parcel$export($5d8ec86348a5c657$exports, "DN800A", () => $5d8ec86348a5c657$export$fe151285c22759ec);
$parcel$export($5d8ec86348a5c657$exports, "DN700A", () => $5d8ec86348a5c657$export$a101c6190d0da34);
$parcel$export($5d8ec86348a5c657$exports, "DN600A", () => $5d8ec86348a5c657$export$4b16f52932fda51);
$parcel$export($5d8ec86348a5c657$exports, "DN500A", () => $5d8ec86348a5c657$export$a74bcd7b9845b0d8);
$parcel$export($5d8ec86348a5c657$exports, "DN400A", () => $5d8ec86348a5c657$export$9209c179316d1751);
$parcel$export($5d8ec86348a5c657$exports, "DN300A", () => $5d8ec86348a5c657$export$88f55133f636c8dd);
$parcel$export($5d8ec86348a5c657$exports, "DN200A", () => $5d8ec86348a5c657$export$51126f85d1009512);
$parcel$export($5d8ec86348a5c657$exports, "DN100A", () => $5d8ec86348a5c657$export$a069b547bd23af78);
$parcel$export($5d8ec86348a5c657$exports, "DN90A", () => $5d8ec86348a5c657$export$40cce05af3b2600a);
$parcel$export($5d8ec86348a5c657$exports, "DN80A", () => $5d8ec86348a5c657$export$b78942185925a0d);
$parcel$export($5d8ec86348a5c657$exports, "DN70A", () => $5d8ec86348a5c657$export$e058fb44b8eaafca);
$parcel$export($5d8ec86348a5c657$exports, "DN60A", () => $5d8ec86348a5c657$export$92b0b8de26920c18);
$parcel$export($5d8ec86348a5c657$exports, "DN50A", () => $5d8ec86348a5c657$export$67564f7459d3fc9e);
$parcel$export($5d8ec86348a5c657$exports, "DN40A", () => $5d8ec86348a5c657$export$77868e1ca884ffa3);
$parcel$export($5d8ec86348a5c657$exports, "DN30A", () => $5d8ec86348a5c657$export$2afd71d7d3ea2cd5);
$parcel$export($5d8ec86348a5c657$exports, "DN20A", () => $5d8ec86348a5c657$export$f2a0acaab9972c70);
$parcel$export($5d8ec86348a5c657$exports, "DN10A", () => $5d8ec86348a5c657$export$9ab70e67d6475361);
$parcel$export($5d8ec86348a5c657$exports, "T30", () => $5d8ec86348a5c657$export$d2adc5dedf09fced);
$parcel$export($5d8ec86348a5c657$exports, "L50", () => $5d8ec86348a5c657$export$f51762073d2bb381);
$parcel$export($5d8ec86348a5c657$exports, "L75", () => $5d8ec86348a5c657$export$95e26d54def96891);
// Reds
const $5d8ec86348a5c657$export$4b84fd0e2c617bd = '#FFEBE6';
const $5d8ec86348a5c657$export$b34b069eff244586 = '#FFBDAD';
const $5d8ec86348a5c657$export$be802dd0d8b57f35 = '#FF8F73';
const $5d8ec86348a5c657$export$60847d42f9da92a6 = '#FF7452';
const $5d8ec86348a5c657$export$4a7404f376229999 = '#FF5630';
const $5d8ec86348a5c657$export$2010d0fb4295b346 = '#DE350B';
const $5d8ec86348a5c657$export$2837b5a1a71d5c02 = '#BF2600';
const $5d8ec86348a5c657$export$8d9596b529bbb9cf = '#FFFAE6';
const $5d8ec86348a5c657$export$41060a744ab0b7ae = '#FFF0B3';
const $5d8ec86348a5c657$export$1cc05bbbf340e559 = '#FFE380';
const $5d8ec86348a5c657$export$5aae31392d72caaa = '#FFC400';
const $5d8ec86348a5c657$export$c6930421db9fa514 = '#FFAB00';
const $5d8ec86348a5c657$export$59619663aa6500fb = '#FF991F';
const $5d8ec86348a5c657$export$874739ea9e379ab6 = '#FF8B00';
const $5d8ec86348a5c657$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5d8ec86348a5c657$export$69a3bf21b9686c2b = '#ABF5D1';
const $5d8ec86348a5c657$export$afbce1382ec95f73 = '#79F2C0';
const $5d8ec86348a5c657$export$747d86715d4175de = '#57D9A3';
const $5d8ec86348a5c657$export$940e1f69e873f202 = '#36B37E';
const $5d8ec86348a5c657$export$a49394138f7b8e85 = '#00875A';
const $5d8ec86348a5c657$export$6fa04827ac68a4fb = '#006644';
const $5d8ec86348a5c657$export$226de0355ed012f8 = '#DEEBFF';
const $5d8ec86348a5c657$export$8c13c2ee36917869 = '#B3D4FF';
const $5d8ec86348a5c657$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5d8ec86348a5c657$export$215b7063051591f1 = '#2684FF';
const $5d8ec86348a5c657$export$e62e8919cca44969 = '#0065FF';
const $5d8ec86348a5c657$export$b3de0ae08da2ce64 = '#0052CC';
const $5d8ec86348a5c657$export$a6ee3d71bc067634 = '#0747A6';
const $5d8ec86348a5c657$export$67f15409e87642a1 = '#669DF1';
const $5d8ec86348a5c657$export$f0539dbc42dbb067 = '#8FB8F6';
const $5d8ec86348a5c657$export$363e4475840015bb = '#EAE6FF';
const $5d8ec86348a5c657$export$4b0a4417ed59760f = '#C0B6F2';
const $5d8ec86348a5c657$export$6011520a64d9a187 = '#998DD9';
const $5d8ec86348a5c657$export$a7175d4e9206bc80 = '#8777D9';
const $5d8ec86348a5c657$export$b48405b95304b5a1 = '#6554C0';
const $5d8ec86348a5c657$export$c71e4279dd54a18d = '#5243AA';
const $5d8ec86348a5c657$export$147899de772240ec = '#403294';
const $5d8ec86348a5c657$export$2cf711fe14c66f06 = '#E6FCFF';
const $5d8ec86348a5c657$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5d8ec86348a5c657$export$776c9c497ef08533 = '#79E2F2';
const $5d8ec86348a5c657$export$69cb3ca10c1e330e = '#00C7E6';
const $5d8ec86348a5c657$export$9dc1ef0f3f48059b = '#00B8D9';
const $5d8ec86348a5c657$export$7c835c78b6fcdef8 = '#00A3BF';
const $5d8ec86348a5c657$export$6036577f95c3877e = '#008DA6';
const $5d8ec86348a5c657$export$29a4f05edc054374 = '#FFFFFF';
const $5d8ec86348a5c657$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5d8ec86348a5c657$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5d8ec86348a5c657$export$3e51e8f1440314ba = '#EBECF0';
const $5d8ec86348a5c657$export$1ce2d1575d444ceb = '#DFE1E6';
const $5d8ec86348a5c657$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5d8ec86348a5c657$export$c2e91cbeada39b8b = '#B3BAC5';
const $5d8ec86348a5c657$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5d8ec86348a5c657$export$eaa8c8a70ac22806 = '#97A0AF';
const $5d8ec86348a5c657$export$7c87d337fb91a97d = '#8993A4';
const $5d8ec86348a5c657$export$d6447c357493214f = '#7A869A';
const $5d8ec86348a5c657$export$f563ee71e9ee74cd = '#6B778C';
const $5d8ec86348a5c657$export$e2ef2124cf4024b1 = '#5E6C84';
const $5d8ec86348a5c657$export$eece5f492e429f08 = '#505F79';
const $5d8ec86348a5c657$export$c39c0fe0f26207ae = '#42526E';
const $5d8ec86348a5c657$export$7090862dc3038a9f = '#344563';
const $5d8ec86348a5c657$export$ad0bacf983b7ddaa = '#253858';
const $5d8ec86348a5c657$export$7d61b15e0da132af = '#172B4D';
const $5d8ec86348a5c657$export$fbda843f0a27fe96 = '#091E42';
const $5d8ec86348a5c657$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5d8ec86348a5c657$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5d8ec86348a5c657$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5d8ec86348a5c657$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5d8ec86348a5c657$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5d8ec86348a5c657$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5d8ec86348a5c657$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5d8ec86348a5c657$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5d8ec86348a5c657$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5d8ec86348a5c657$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5d8ec86348a5c657$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5d8ec86348a5c657$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5d8ec86348a5c657$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5d8ec86348a5c657$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5d8ec86348a5c657$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5d8ec86348a5c657$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5d8ec86348a5c657$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5d8ec86348a5c657$export$2f6319cf7d736c2a = '#E6EDFA';
const $5d8ec86348a5c657$export$95126bc8884d6634 = '#DCE5F5';
const $5d8ec86348a5c657$export$8338d8c35d44ff1 = '#CED9EB';
const $5d8ec86348a5c657$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5d8ec86348a5c657$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5d8ec86348a5c657$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5d8ec86348a5c657$export$97e81faa16a182c7 = '#8C9CB8';
const $5d8ec86348a5c657$export$bfe21c59123ecf33 = '#7988A3';
const $5d8ec86348a5c657$export$ee82aa2ea6a1558 = '#67758F';
const $5d8ec86348a5c657$export$682927c6ed76be02 = '#56637A';
const $5d8ec86348a5c657$export$91fd9994c5be9757 = '#455166';
const $5d8ec86348a5c657$export$d281fbfe3cff2df6 = '#3B475C';
const $5d8ec86348a5c657$export$3902c91d8b98a753 = '#313D52';
const $5d8ec86348a5c657$export$8e8133c1ba5845b5 = '#283447';
const $5d8ec86348a5c657$export$33ff357f6620b39 = '#202B3D';
const $5d8ec86348a5c657$export$633847cf062b69e0 = '#1B2638';
const $5d8ec86348a5c657$export$9776a6e503bdbf76 = '#121A29';
const $5d8ec86348a5c657$export$6c813d5160dff5db = '#0E1624';
const $5d8ec86348a5c657$export$3d4f271a500072a = '#0D1424';
const $5d8ec86348a5c657$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5d8ec86348a5c657$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5d8ec86348a5c657$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5d8ec86348a5c657$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5d8ec86348a5c657$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5d8ec86348a5c657$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5d8ec86348a5c657$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5d8ec86348a5c657$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5d8ec86348a5c657$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5d8ec86348a5c657$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5d8ec86348a5c657$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5d8ec86348a5c657$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5d8ec86348a5c657$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5d8ec86348a5c657$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5d8ec86348a5c657$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5d8ec86348a5c657$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5d8ec86348a5c657$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5d8ec86348a5c657$export$d2adc5dedf09fced = '#292A2E';
const $5d8ec86348a5c657$export$f51762073d2bb381 = '#94C748';
const $5d8ec86348a5c657$export$95e26d54def96891 = '#B3DF72';

parcelRegister("1fVOO", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f2c6f11cd97d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $ggS4Q = parcelRequire("ggS4Q");

var $4eF0x = parcelRequire("4eF0x");

const $b752f2c6f11cd97d$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'sticky',
    top: '0px',
    background: `${`var(--ds-surface, ${(0, $5d8ec86348a5c657$export$9fdfb749e33cdf97)})`}`
});
const $b752f2c6f11cd97d$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `${"var(--ds-border-width-selected, 2px)"} solid ${`var(--ds-border, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`}`,
        borderRadius: "var(--ds-radius-small, 4px)",
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${`var(--ds-surface-overlay, ${(0, $5d8ec86348a5c657$export$9fdfb749e33cdf97)})`}`,
        color: `${"var(--ds-icon, rgb(66, 82, 110))"}`,
        '&:hover': {
            borderWidth: "var(--ds-border-width-selected, 2px)",
            backgroundColor: `${`var(--ds-surface-overlay-hovered, ${(0, $5d8ec86348a5c657$export$3e51e8f1440314ba)})`}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${`var(--ds-background-neutral-bold-pressed, ${(0, $5d8ec86348a5c657$export$ad0bacf983b7ddaa)})`}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${`var(--ds-icon-inverse, ${(0, $5d8ec86348a5c657$export$29a4f05edc054374)})`} !important`
        }
    }
});
const $b752f2c6f11cd97d$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $b752f2c6f11cd97d$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $b752f2c6f11cd97d$var$codeBlockButtonsStyle
    }, allowWrapCodeBlock && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4eF0x.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $ggS4Q.default), {
        content: text
    })));
};
var $b752f2c6f11cd97d$export$2e2bcd8739ae039 = $b752f2c6f11cd97d$var$CodeBlockButtonContainer;

});
parcelRegister("ggS4Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $105f7b7cde762fc2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $RIJMT = parcelRequire("RIJMT");

var $grQa7 = parcelRequire("grQa7");

var $9OKAp = parcelRequire("9OKAp");

var $k0cow = parcelRequire("k0cow");

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $8jJqh = parcelRequire("8jJqh");

var $lJWkX = parcelRequire("lJWkX");

var $bdy2l = parcelRequire("bdy2l");
const $105f7b7cde762fc2$var$CopyButton = ({ content: content, intl: intl })=>{
    const [tooltip, setTooltip] = (0, $eJOHy.useState)(intl.formatMessage((0, $grQa7.codeBlockButtonMessages).copyCodeToClipboard));
    const [className, setClassName] = (0, $eJOHy.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage((0, $grQa7.codeBlockButtonMessages).copyCodeToClipboard));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8jJqh.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k0cow.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $RIJMT.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9OKAp))), {
                label: tooltip
            }),
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $lJWkX.ACTION).CLICKED,
                    actionSubject: (0, $lJWkX.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $lJWkX.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $lJWkX.EVENT_TYPE).UI
                });
                (0, $bdy2l.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $grQa7.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
var $105f7b7cde762fc2$export$2e2bcd8739ae039 = (0, $6YFG2.default)($105f7b7cde762fc2$var$CopyButton);

});
parcelRegister("9OKAp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c375ed2b41c84b45c85c51ed117e320a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $725ceba41ec98b02$var$_react = $725ceba41ec98b02$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $725ceba41ec98b02$var$_copy = $725ceba41ec98b02$var$_interopRequireDefault((parcelRequire("kaqhT")));

var $725ceba41ec98b02$var$_copy2 = $725ceba41ec98b02$var$_interopRequireDefault((parcelRequire("fjRxX")));
function $725ceba41ec98b02$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $725ceba41ec98b02$var$CopyIcon = (props)=>/*#__PURE__*/ $725ceba41ec98b02$var$_react.default.createElement($725ceba41ec98b02$var$_copy.default, Object.assign({
        name: "CopyIcon",
        LEGACY_fallbackIcon: $725ceba41ec98b02$var$_copy2.default
    }, props));
$725ceba41ec98b02$var$CopyIcon.displayName = 'CopyIconMigration';
var $725ceba41ec98b02$var$_default = module.exports.default = $725ceba41ec98b02$var$CopyIcon;

});
parcelRegister("fjRxX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2722aa1ceff90e1$var$_react = $b2722aa1ceff90e1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $jJt6S = parcelRequire("jJt6S");
function $b2722aa1ceff90e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b2722aa1ceff90e1$var$CopyIcon = (props)=>/*#__PURE__*/ $b2722aa1ceff90e1$var$_react.default.createElement($jJt6S.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props));
$b2722aa1ceff90e1$var$CopyIcon.displayName = 'CopyIcon';
var $b2722aa1ceff90e1$var$_default = module.exports.default = $b2722aa1ceff90e1$var$CopyIcon;

});



parcelRegister("4eF0x", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b68efdd9244ace1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $RIJMT = parcelRequire("RIJMT");

var $grQa7 = parcelRequire("grQa7");

var $jJt6S = parcelRequire("jJt6S");

var $k0cow = parcelRequire("k0cow");

var $8jJqh = parcelRequire("8jJqh");

var $lJWkX = parcelRequire("lJWkX");
const $2b68efdd9244ace1$var$WrapIcon = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("g", {
        fill: "currentColor",
        clipPath: "url(#clip0_654_431)"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })));
};
const $2b68efdd9244ace1$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $grQa7.codeBlockButtonMessages).unwrapCode : (0, $grQa7.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8jJqh.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k0cow.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $RIJMT.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jJt6S.default), {
                glyph: $2b68efdd9244ace1$var$WrapIcon,
                label: ""
            }),
            isSelected: wrapLongLines,
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $lJWkX.ACTION).CLICKED,
                    actionSubject: (0, $lJWkX.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $lJWkX.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $lJWkX.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
var $2b68efdd9244ace1$export$2e2bcd8739ae039 = (0, $6YFG2.default)($2b68efdd9244ace1$var$CodeBlockWrapButton);

});



parcelRegister("5rPMS", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("8mKjW").then(()=>parcelRequire('1ThzG'));

});



//# sourceMappingURL=@atlaskit-internal_renderer-node_WindowedCodeBlock.a8fa558a.js.map
